import { Stack, Text, Grid, Box } from '@chakra-ui/react'
import { SectionTitle } from '../section-title'
import { partners } from './partners'
import { PartnerCard } from './partner'

const data = {
  title: 'Our Partners',
  text: 'Thanks to our partners, we are able to provide full service support as we aspire to grow bigger and stronger together!',
}

export const PartnerOverview = () => {
  return (
    <Stack bgColor="txtBlue" gap={32} py="4rem" px={{ base: '2rem', md: '4rem' }} w="full">
      <Stack gap={16}>
        <SectionTitle title={data.title} />
        <Box w={{ base: 'full', md: 1 / 3 }}>
          <Text color="txtWhite">{data.text}</Text>
        </Box>
      </Stack>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          lg: 'repeat(2, 1fr)',
        }}
        gap={6}
      >
        {partners.map((partner) => (
          <PartnerCard key={partner.name} partner={partner} />
        ))}
      </Grid>
    </Stack>
  )
}
